import React from 'react';
import { Tag } from 'shared/assets/icons';
import { Icon } from 'shared/components/ui/icon';
import { useRelationshipIdsById } from 'shared/hooks/use-relationships';
import { ID, IDPrefixes } from 'shared/types/id';

import * as Styled from './task-card-header.style';

export type TagIconProps = {
  id: ID;
};

export const TagIcon: React.FC<TagIconProps> = ({ id }) => {
  const { tag: tagIds } = useRelationshipIdsById(id, IDPrefixes.Task);

  return tagIds.length ? (
    <Styled.IconContainer>
      <Icon icon={Tag} />
    </Styled.IconContainer>
  ) : null;
};
